// Normalizes the three "list the company's items" endpoints into a single [{id, name}] shape the
// automation builder's IdPicker can render. Each new assign brick (program / nutrition / form) maps a
// picked id into its templateId/menuTemplateId/formTemplateId input — the user picks by NAME, never a
// raw id. Reuses the existing admin list services (no new endpoints).

import {getTemplates} from "../../../services/TemplatesService";
import {listMenuTemplates} from "../../../services/NutritionV2Service";
import {getFormTemplates} from "../../../services/FormTemplateService";

// Pull a list of rows out of whatever shape a service returns (array, {content}, {data}, {data:{content}}).
const rows = (res) => {
    const d = res?.data ?? res;
    if (Array.isArray(d)) return d;
    if (Array.isArray(d?.content)) return d.content;
    if (Array.isArray(d?.data)) return d.data;
    if (Array.isArray(d?.data?.content)) return d.data.content;
    return [];
};

const opt = (r) => ({
    id: r.id ?? r.templateId ?? r.menuId,
    name: r.name || r.nameHeb || r.menuName || r.title || `#${r.id ?? r.templateId}`,
});

// picker key (from nodeCatalog target.picker) → an async loader returning [{id, name}].
const LOADERS = {
    program: async (companyId) => {
        // getTemplates(page, size, ...many filters..., companyId at position 12)
        const res = await getTemplates(0, 1000, undefined, undefined, undefined, undefined,
            undefined, true /* enabled only */, undefined, undefined, undefined, companyId || null);
        return rows(res).map(opt);
    },
    nutrition: async () => {
        // Nutrition V2 menu templates. This listed the V1 global templates until the cutover, and
        // the ids are not interchangeable — a V1 template and the V2 copy of it are different rows.
        // The brick fails loudly on an id it cannot resolve rather than assigning some other menu,
        // so a flow saved before the switch asks for its menu to be re-picked instead of quietly
        // handing the trainee a plan nobody chose.
        //
        // Templates resolve to the caller's company. A super-admin targeting another company's
        // menus does so via impersonation (no cross-company companyId param).
        return (await listMenuTemplates()).map(opt);
    },
    form: async (companyId) => {
        const res = await getFormTemplates(0, 1000, companyId || null);
        return rows(res).map(opt);
    },
};

export async function loadPickerOptions(pickerKey, companyId) {
    const loader = LOADERS[pickerKey];
    if (!loader) return [];
    try {
        return await loader(companyId);
    } catch (e) {
        return [];
    }
}
